import { render, staticRenderFns } from "./activity-wiper-video.vue?vue&type=template&id=08a9a022&scoped=true&"
import script from "./activity-wiper-video.vue?vue&type=script&lang=js&"
export * from "./activity-wiper-video.vue?vue&type=script&lang=js&"
import style0 from "./activity-wiper-video.vue?vue&type=style&index=0&id=08a9a022&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a9a022",
  null
  
)

export default component.exports